import { derived, get } from 'svelte/store';

import type { IAlarmZone } from 'src/components/AlarmZones/AlarmWizard/alarm_object';
import { set_alarms_data_android, set_scenes_data_android } from 'src/services/lists_update_android';
import { set_alarms_data_ios, set_scenes_data_ios } from 'src/services/lists_update_ios';

import { app, os } from 'src/stores/session/native-bridge';
import { user_data } from '../account/user';
import { scenes } from './scenes';

function fixOldAlarmData(alarms: IAlarmZone): any {
	//extract notifyUI : { type: 'alarm', triggered: true } and push it into blk array
	// add _enable_delay and _enable_delay_units to old alarms

	Object.values(alarms).forEach((alarm, index) => {
		if (Array.isArray(alarm.do) && alarm.do.length >= 0) {
			const notifyUI = alarm.do.find((obj) => obj.notifyUI);

			if (notifyUI) {
				const blkObj = alarm.do.find((obj) => obj.do && Array.isArray(obj.do.blk));
				if (blkObj) {
					blkObj.do.blk = blkObj.do.blk || [];
					blkObj.do.blk.push(notifyUI);
					alarm.do = alarm.do.filter((obj) => !obj.notifyUI);
				}
			}
		}
		if (!alarm.hasOwnProperty('_enable_delay')) {
			alarm._enable_delay = 0;
			alarm._meta.enable_delay_units = 'sec';
		}

		if (typeof alarm._meta?.position === 'undefined') {
			alarm._meta.position = index;
		}
	});

	return alarms;
}

export const alarms = derived([scenes], ([$scenes]) => {
	let alarmsMap = {};
	Object.entries($scenes).filter((i: any) => {
		if (i[1]._gui_function === 'alarm') {
			alarmsMap[i[0]] = i[1];
		}
	});

	alarmsMap = fixOldAlarmData(alarmsMap);
	return alarmsMap;
});

alarms.subscribe((val) => {
	if (get(app) && get(user_data).email) {
		console.log('send list data to native ', 'ALARMS', val);
		if (get(os) === 'IOS') {
			set_alarms_data_ios(val);
		} else {
			set_alarms_data_android(val);
		}
	}
});

scenes.subscribe((val) => {
	if (get(app) && get(user_data).email) {
		console.log('send list data to native ', 'SCENES', val);
		if (get(os) === 'IOS') {
			set_scenes_data_ios(val);
		} else {
			set_scenes_data_android(val);
		}
	}
});

export const temp_schemes = derived([scenes], ([$scenes]) => {
	const temp_schemesMap = {};
	Object.entries($scenes).filter((i) => {
		if (i[1].hasOwnProperty('tschem')) {
			temp_schemesMap[i[0]] = i[1];
		}
	});

	Object.values(temp_schemesMap).forEach((val: any, index) => {
		if (!val.id && val._id) {
			val.id = val._id;
		}
		if (val._meta !== undefined && !val?._meta.hasOwnProperty('C')) {
			val._meta = {
				...val._meta,
				F: {
					heat: {
						min: '41',
						max: '95',
					},
					cool: {
						min: '41',
						max: '95',
					},
				},
				C: {
					heat: {
						min: '5',
						max: '35',
					},
					cool: {
						min: '5',
						max: '35',
					},
				},
			};
		}
	});

	return temp_schemesMap;
});

export const notify_alexa = derived([user_data, scenes], ([$user_data, $scenes]) => {
	const _active_cnt =
		Object.values($scenes).filter((el) => {
			if (typeof el !== 'undefined' && typeof el.do !== 'undefined') {
				return el.do.find((_do) => {
					return (
						_do.notify === 'alexa_notif' ||
						(_do?.do && _do.do?.blk && _do?.do?.blk[0]?.notify === 'alexa_notif')
					);
				});
			}
		}).length || 0;

	const not_premium_cnt =
		Object.values($scenes).filter((el) => {
			if (typeof el !== 'undefined' && typeof el.do !== 'undefined') {
				return el.do.find((_do) => {
					return (
						(_do.notify === 'alexa_notif' && _do.type !== 'premium') ||
						(_do?.do &&
							_do?.do?.blk &&
							_do?.do?.blk[0]?.notify === 'alexa_notif' &&
							_do?.do?.blk[0]?.type !== 'premium')
					);
				});
			}
		}).length || 0;

	return {
		_active_cnt: _active_cnt,
		_not_premium_cnt: not_premium_cnt,
		_max_not_premium: 3,
		_max: $user_data.premium ? 100 : 3,
	};
});
